import { useMytaverseEvent } from '@core/dashboard/providers';

// The branding record the editor should read from and write to.
//
// `currentBrandingId` cannot be used on its own: it starts as null and is only ever set by
// AdminTools, after that panel loads the branding list for the map. An author who never opens
// Admin Tools — the normal case on a fresh page load — leaves it null, which silently turned
// both the layout save and the layout restore into no-ops.
//
// The room record carries the answer already, so fall back to it. AdminTools resolves the same
// way (`room?.activeBrandingId ?? currentRoom?.activeBrandingId`), which is what makes this a
// fallback rather than a second source of truth.
//
// Order matters: `currentBrandingId` wins when it is set, because Admin Tools is how an author
// switches to a draft branding, and edits must follow them there rather than snapping back to
// whichever branding is live.
export const useActiveBrandingId = (): string | null => {
  const { currentBrandingId, currentRoom } = useMytaverseEvent();

  return currentBrandingId ?? currentRoom?.activeBrandingId ?? null;
};
